import { handleActions } from 'redux-actions';
import { TOGGLE_MENU, COLLAPSE_MENU, UNCOLLAPSE_MENU, SHOW_MENU, HIDE_MENU } from './actions';

/**
 * The initial state if no state is provided.
 * @type {Object}
 */
const initialState = {
  isCollapsed: true,
  menuVisible: true
};

const toggleMenu = (state = initialState) => {
  return {
    ...state,
    isCollapsed: !state.isCollapsed
  };
};

const collapseMenu = (state = initialState) => {
  return {
    ...state,
    isCollapsed: true
  };
};

const uncollapseMenu = (state = initialState) => {
  return {
    ...state,
    isCollapsed: false
  };
};

const showMenu = (state = initialState) => {
  return {
    ...state,
    menuVisible: true
  };
};

const hideMenu = (state = initialState) => {
  return {
    ...state,
    menuVisible: true
  };
};

const reducer = handleActions(
  {
    [TOGGLE_MENU]: toggleMenu,
    [UNCOLLAPSE_MENU]: uncollapseMenu,
    [COLLAPSE_MENU]: collapseMenu,
    [SHOW_MENU]: showMenu,
    [HIDE_MENU]: hideMenu
  },
  initialState
);

export default reducer;
